<template>
    <div id="viewInvoiceDetailModal" ref="viewInvoiceDetailModal" class="modal fade fxModal" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered laptop:!max-w-[60%] largeDesktop:!max-w-[40%]">
            <div class="modal-content">
                <div class="modal-body !p-[25px] flex flex-col gap-[30px]">
                    <FxModalHeader title="Invoice Detail" :dismiss="false" @close="hide()" />
                    <div v-if="!loading" class="flex flex-col gap-[20px]">
                        <div
                            class="relative flex flex-col gap-[20px] mobile:pt-[20px] mobile:p-[10px] laptop:p-[10px] rounded-[10px] border-[1px] border-[#CCCCCC] bg-[#EFEFEF]/50">
                            <div class="grid grid-cols-3 laptop:grid-cols-4 gap-[10px]">
                                <div class="flex flex-col gap-[3px]">
                                    <h6 class="m-0 text-lato font-normal font-[14px] text-[#666]">ID:</h6>
                                    <p class="m-0 text-lato font-normal font-[14px] text-[#333]">
                                        {{ invoiceDetail?.id }}</p>
                                </div>
                                <div class="flex flex-col gap-[3px]">
                                    <h6 class="m-0 text-lato font-normal font-[14px] text-[#666]">Payment Type:</h6>
                                    <p class="m-0 text-lato font-normal font-[14px] text-[#333]">{{
                                        invoiceDetail?.payment_type }}</p>
                                </div>
                                <div class="flex flex-col gap-[3px]">
                                    <h6 class="m-0 text-lato font-normal font-[14px] text-[#666]">Amount:</h6>
                                    <p class="m-0 text-lato font-normal font-[14px] text-[#333]">
                                        ${{ $helper.formatAmount(invoiceDetail?.amount) }}</p>
                                </div>
                                <div class="hidden laptop:flex flex-col gap-[3px]">
                                    <h6 class="m-0 text-lato font-normal font-[14px] text-[#666]">Status:</h6>
                                    <p v-if="invoiceDetail?.status == 'Paid'"
                                        class="w-max m-0 px-[5px] py-[1px] rounded-[3px] font-roboto text-[12px] font-normal text-[#fff] bg-[#65B741]">
                                        {{ invoiceDetail?.status }}</p>
                                    <p v-else
                                        class="w-max m-0 px-[5px] py-[1px] rounded-[3px] font-roboto text-[12px] font-normal text-[#fff] bg-[#F59E0B]">
                                        {{ invoiceDetail?.status }}</p>
                                </div>
                            </div>
                            <div class="grid grid-cols-2 gap-[10px]">
                                <div class="flex flex-col gap-[3px]">
                                    <h6 class="m-0 text-lato font-normal font-[14px] text-[#666]">Created Datetime:</h6>
                                    <p class="m-0 text-lato font-normal font-[14px] text-[#333]">
                                        {{ invoiceDetail?.date != null &&
                                            invoiceDetail?.date !== ''
                                            ? $helper.formatDateTime(invoiceDetail?.date)
                                            : '-' }}
                                    </p>
                                </div>
                                <div class="flex flex-col gap-[3px]">
                                    <h6 class="m-0 text-lato font-normal font-[14px] text-[#666]">Paid Date:</h6>
                                    <p class="m-0 text-lato font-normal font-[14px] text-[#333]">
                                        {{ invoiceDetail?.paid_date != null &&
                                            invoiceDetail?.paid_date !== ''
                                            ? $helper.formattedDate(invoiceDetail?.paid_date)
                                            : '-' }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="laptop:hidden absolute -top-[18px] right-[15px] z-[1] group flex items-center gap-[5px] rounded-full px-[10px] py-[5px] border-[1px] border-[#CCCCCC] bg-gradient-to-r from-[#FFFFFF] to-[#F1F1F1]">
                                <div class="flex items-center gap-[10px]">
                                    <p class="m-0 font-roboto text-[14px] font-normal text-[#999]">Status:</p>
                                    <p v-if="invoiceDetail?.status == 'Paid'"
                                        class="w-max m-0 px-[5px] py-[1px] rounded-full font-roboto text-[12px] font-normal text-[#fff] bg-[#65B741]">
                                        {{ invoiceDetail?.status }}</p>
                                    <p v-else
                                        class="w-max m-0 px-[5px] py-[1px] rounded-full font-roboto text-[12px] font-normal text-[#fff] bg-[#F59E0B]">
                                        {{ invoiceDetail?.status }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-[10px]">
                            <h4 class="m-0 text-lato font-bold text-[18px] text-[#6C79E0]">Item(s) Name:</h4>
                            <div class="pr-[10px] max-h-[200px] overflow-auto customScrollbar">
                                <ul class="m-0 list-inline flex flex-col gap-[5px]">
                                    <li v-for="(item, index) in (Array.isArray(invoiceItemList) ? invoiceItemList : [])"
                                        :key="item.id || index"
                                        class="p-[10px] rounded-[5px] text-lato font-normal font-[16px] text-[#333] bg-[#EFEFEF]/50">
                                        {{ item.name || item.value }}
                                    </li>
                                    <li v-if="!Array.isArray(invoiceItemList) || !invoiceItemList.length"
                                        class="p-[10px] rounded-[5px] text-lato font-normal font-[16px] text-[#999] bg-[#EFEFEF]/50 text-center">
                                        No Items Available
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
    components: { FxModalHeader },
    props: ["invoiceDetail"],

    data() {
        return {
            modal: null,
            loading: true,
            source: ''
        };
    },

    computed: {
        ...mapGetters(["invoiceItemList"]),
    },

    watch: {
        invoiceItemList: function () {

            if (this.source == 'detail') {
                if (!this.modal) {
                    this.modal = new Modal(this.$refs.viewInvoiceDetailModal, {
                        backdrop: 'static',
                        keyboard: false
                    });
                    this?.modal?.show();

                }
            }

        }
    },

    mounted() {
    },

    methods: {
        ...mapActions(["getInvoiceItem"]),

        async show() {
            this.loading = true;
            this.source = 'detail'

            if (this.invoiceDetail && this.invoiceDetail.id) {
                try {
                    await this.getInvoiceItem({
                        job_type: 'sar',
                        job_id: this.$route.params.id,
                        source: 'edit',
                        invoice_id: this.invoiceDetail.id
                    });
                } catch (err) {
                    console.error("Error loading invoice items:", err);
                } finally {
                    this.loading = false;
                }
            } else {
                this.loading = false;
            }
        },

        hide() {
            this.source = ''
            this.modal?.hide();
        },

    }
}
</script>